import styled from 'styled-components'

interface PropsType {
  count: number
}

const WorksCountText = styled.div`
  font-size: 14px;
  margin-right: 15px;
  text-align: right;
  width: 240px;
`

const WorksCountNumber = styled.span`
  font-size: 24px;
  font-weight: bold;
`

const WorksCount = (props: PropsType) => {
  const worksCountNumber = props.count.toLocaleString()
  return (
    <WorksCountText>
      ヒットする件数&nbsp;<WorksCountNumber>{worksCountNumber}</WorksCountNumber>件
    </WorksCountText>
  )
}

export default WorksCount
